import { CustomValueComponentIdentifierKeys } from "@/store/resource-details/utils/types/resourceAdditionalDetails";
import { listingPriceColumnDefField } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const isCustomValueComponentIdentifierKeys = (
  key?: string,
): key is CustomValueComponentIdentifierKeys => {
  return key === listingPriceColumnDefField;
};
